import { Input } from '@heroui/react';
import React, { FC } from 'react';

interface NumberFieldProps {
  label: string;
  value: number;
  onChange: (value: number) => void;
  step?: number;
  min?: number;
  max?: number;
}

export const NumberField: FC<NumberFieldProps> = ({ label, value, onChange, step = 1, min, max }) => (
  <Input
    size="sm"
    radius="sm"
    type="number"
    label={label}
    labelPlacement="outside"
    step={step}
    min={min}
    max={max}
    value={String(Math.round(value))}
    onValueChange={(next) => {
      const parsed = Number(next);
      if (!Number.isNaN(parsed)) onChange(parsed);
    }}
  />
);
